import { render, staticRenderFns } from "./ResearchSingleSearchCFDEllm.vue?vue&type=template&id=7bd51766&scoped=true"
import script from "./ResearchSingleSearchCFDEllm.vue?vue&type=script&lang=js"
export * from "./ResearchSingleSearchCFDEllm.vue?vue&type=script&lang=js"
import style0 from "./ResearchSingleSearchCFDEllm.vue?vue&type=style&index=0&id=7bd51766&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd51766",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bd51766')) {
      api.createRecord('7bd51766', component.options)
    } else {
      api.reload('7bd51766', component.options)
    }
    module.hot.accept("./ResearchSingleSearchCFDEllm.vue?vue&type=template&id=7bd51766&scoped=true", function () {
      api.rerender('7bd51766', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchSingleSearchCFDEllm.vue"
export default component.exports